export default __webpack_public_path__ + "static/media/messi.1a9b068d.jpeg";